<template>
    <div class=" row no-gutters justify-content-center text-center otpverification mb-3">
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
         <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="whiteBG p-3 middleBox ">
            <div class="mainTitle text-center mt-4 mb-3 ">
                <h2 class="mb-2"> {{$t('otpVerif_otpVerification')}}</h2>
                <!-- <small class="d-block mb-4"> {{$t('otpVerificationText')}}</small> -->
                <p class="mb-0" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1" v-html="$t('googleOtp')"></p> 
                <p class="mb-0" v-else> {{$t('otpVerif_otpVerificationText1')}}</p> 
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-0 px-4 mb-4"> 
                <img class="otp mb-3" src="../../../../../static/fxView/images/otp.svg" alt="one time password">
                
                <div class="form-group field-wrapper" > 
                    <input placeholder="Verfication Code" class="float-field form-control" v-model="otp" name="otp" type="text" v-validate="{ required: true, max: 6,numeric : true }" :class="{ 'is-invalid': submitted && errors.has('otp') }" ref="otpInput">
                    <!-- <label for="username" class="float-label"> {{$t('verifyCode')}}</label> -->   
                    <p class="error" v-for="error in errors.collect('otp')">{{ error }}</p>   
                </div>   
                <div class="clearfix"></div>
                <div class="validatebtn d-flex align-items-center justify-content-center mb-3">
                    
                    <button class="prism_btn btn_sm " v-on:click.prevent="submit()"> {{$t('sub_validate')}} </button>  
                </div>
                
            </div>
            <div class="w-100 px-4">
                <div class=" d-flex justify-content-between align-items-center">
                    <div class="text-center">
                        <a href="#" class="underline" v-on:click.prevent="resendOtp()"> {{$t('otpVerif_resendOtpTicket')}}</a>
                    </div>
                
                    <div class="text-center" v-if="ticketRequestFrom == 'profileOtp'">
            			<a class=" underline" href="#" @click.prevent="$parent.trans_id = ''">{{$t('otpVerif_back')}}</a>
                    </div>
                    <div class="text-center" v-else-if="ticketRequestFrom == 'bankDeposit' || ticketRequestFrom == 'increase-Limit'">
                        <a class=" underline" href="#" @click.prevent="$parent.trans_id = ''; $parent.shwStep = 2">{{$t('otpVerif_back')}}</a>
                    </div>
            		<div class="text-center" v-else>
                        <a class="darkColor underline" href="#" @click.prevent="$parent.backTick()">{{$t('otpVerif_backToTicket')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'  
    export default {
        mixins:[fxViewMixins],
        data(){
            return {
                'otp' : '',
                'data_msz' :'',
                submitted : false,
                 response_msg : '',
                msg_type : '',
                pageLoader : false,
                gAuthenticatorEnabled : false
            }
        },
        props:['transaction_id','module','data','ticketRequestFrom','accountId','title_parent'],
        methods:{
			resendOtp(){
				let input_json={
					'globalParams' :{
						'trans_id' : this.transaction_id.toString()
					},
					'localParams' :{ "parameter" : this }
				}
				this._runTicketResendOtp(input_json)
			},
            submit(){
                const _that = this
                _that.submitted = true;
                _that.data_msz = _that.data
                _that.$validator.validate().then(valid => {
                    if (valid){
                        let input_json={
                            'globalParams' :{
                                'otp' :  _that.otp.toString(), 
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that , 'module' : _that.module , 'data' : _that.data_msz ,'ticketRequestFrom' : _that.ticketRequestFrom , 'accountId' : _that.accountId ,'title':_that.title_parent}
                        }
                        _that._runTicketCheckOtp(input_json)
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/services/otp_verification.vue